import { render, staticRenderFns } from "./sis-betslip.vue?vue&type=template&id=39ba560b&"
import script from "./sis-betslip.vue?vue&type=script&lang=js&"
export * from "./sis-betslip.vue?vue&type=script&lang=js&"
import style0 from "./sis-betslip.vue?vue&type=style&index=0&id=39ba560b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports